@if (contentChecked) {
  <div cdkDropList
    [id]="dragDropId"
    [cdkDropListData]="dataList"
    [cdkDropListConnectedTo]="connectedDragDropsIds"
    [cdkDropListDisabled]="disabled"
    [cdkDropListEnterPredicate]="boundAllowDrop"
    >
    @for (template of dragDropItems; track template; let i = $index) {
      <div cdkDrag (cdkDragDropped)="itemDropped($event)" [cdkDragData]="dataList[i]">
        <ng-container [ngTemplateOutlet]="template" />
      </div>
    }
    @if (!disabled && dataList?.length === 0) {
      <div class="empty-list">
        <div>{{emptyListMessage}}</div>
      </div>
    }
  </div>
}
@if (disabled && dataList?.length === 0) {
  <tidy-alert class="empty-list-alert">
    <tidy-row [align]="'center'">
      <tidy-text
        [helper]="emptyDisabledListMessage" />
    </tidy-row>
  </tidy-alert>
}
